import { useUserDetails } from '@/hooks';
import { AssignedListsTable } from '@/pages/ListsPage/AssignedListsTable';
import { useAuth0 } from '@auth0/auth0-react';
import { Paper, Stack, Typography } from '@mui/material';
import Container from '@mui/material/Container';
import { Helmet } from 'react-helmet';

export default function HomePage() {
  const { user } = useAuth0();
  const { data: userDetails } = useUserDetails();
  const userLevelNotification =
    !userDetails || !userDetails.userLevel || userDetails.userLevel === 'None'
      ? ''
      : `You are a ${userDetails.userLevel} for this organisation.`;

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>List Manager - Home</title>
        <meta name="description" content="List Manager application - home page" />
      </Helmet>
      <Container style={{ maxWidth: '1500px', padding: '2rem' }}>
        <Stack spacing={4}>
          <Paper sx={{ padding: 2 }}>
            <Typography>
              You are logged in with the username <strong>{user?.name}</strong>.
              {userLevelNotification && <> {userLevelNotification}</>}
            </Typography>
          </Paper>
          <Paper sx={{ padding: 2 }}>
            <Typography
              sx={{
                marginBottom: 1,
                fontWeight: 700
              }}>
              Welcome to {'Release 4'} of the List Manager.
            </Typography>
            <Typography sx={{
              marginBottom: 2
            }}>
              Click &quot;About&quot; in the menu to learn more about the features in this release.
            </Typography>
            <Typography sx={{
              marginBottom: 4
            }}>
              The following table contains the most recent lists that have been assigned to you.
              Click on a list to open it. You can return here by clicking onto the Home icon in the
              navigation bar on the left.
            </Typography>
            <Typography component="h2" variant="h6" sx={{
              marginBottom: 1
            }}>
              Caller assignments
            </Typography>
            <AssignedListsTable onHomepage />
          </Paper>
        </Stack>
      </Container>
    </>
  );
}
